import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';

import ReactMarkdown from 'react-markdown';
import { fetchAuthenticatedUser } from '../../actions';
import log from '../../utils/logging';

function AppleLoginPage() {
    const [isLoading, setLoading] = useState(true);
    const auth = useSelector((state) => state.auth);
    const dispatch = useDispatch();

    const onhandleSignIn = async () => {
        try {
            await dispatch(fetchAuthenticatedUser());
            setLoading(false);
        } catch (e) {
            log.error(e);
        }
    };

    useEffect(() => {
        onhandleSignIn();
    }, []);

    const { error, user } = auth;
    return (
        <div className="container">
            {isLoading
                ? (
                    <div>
                        Signing in...
                    </div>
                )
                : (
                    <div>
                        {error && <div><ReactMarkdown>{`There was an error signing you in: ${error}`}</ReactMarkdown></div>}
                        {user && <Redirect to={'/home'} />}
                    </div>
                )}
        </div>
    );
}

export default {
    component: withRouter(AppleLoginPage),
};
